import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    frame: String,
    url: String
  }

  redirect() {
    Turbo.visit(this.urlValue, {frame: this.frameValue});
  }
}
